import { Children, cloneElement, ElementType, isValidElement, ReactElement } from 'react';

import { isAggregator, isDefined, withKey } from '.';

function formatProperties(type: ElementType | string, data: object | object[] | undefined, inherited: object): object {
  // @ts-ignore
  if (!type.propTypes || !isDefined(data)) {
    return inherited;
  }

  if (isAggregator(type) || Array.isArray(data)) {
    return { ...inherited, data };
  }

  return { ...inherited, ...data };
}

function propagateData(children: ReactElement | ReactElement[], data: object | object[] | undefined, inherited: object = {}, generateKey = false): ReactElement[] {
  return Children.toArray(children)
    .filter((child) => isValidElement(child))
    .map(child => {
      const properties = formatProperties(child.type, data, inherited);
      const props = generateKey ? withKey(properties) : properties;
      return cloneElement(child, props);
    });
}

export default propagateData;
